import { IMsalContext, useMsal } from '@azure/msal-react';
import { AuthStrategy } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { getApi } from '@monorepo/shared/src/api';
import { getAccessToken } from '@monorepo/shared/src/config/educatorApp/auth';
import { useEffect } from 'react';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';

const useSetAuthContextForApi = (useAuth) => {
  const azureContext = useMsal();
  const [{ isAuthenticated }] = useUserStore();

  const setAuthContext = async (azureContext: IMsalContext): Promise<void> => {
    if (!isAuthenticated) return;
    const result = await getAccessToken(azureContext);
    if (result) {
      getApi(AuthStrategy.HTTP_AUTHENTICATION).setAuthContext(result);
    }
  };

  useEffect(() => {
    if (useAuth) {
      const authorizeUser = async () => await setAuthContext(azureContext);
      authorizeUser();
    }
  }, [azureContext, isAuthenticated]);
};

export default useSetAuthContextForApi;
